import React from 'react';
import { Divider } from 'antd';
import LessonPlannerStatusButton from './LessonPlannerStatusButton';

const LessonPlannerClassStatusRow = ({ classStatuses, onStatusChange }) => (
    <>
        <div style={{ padding: '0 16px' }}><Divider className="ch-divider" style={{ margin: '8px 0 8px' }} /></div>
        <div className="ch-lesson-planner-classes-row">
            <div className="ch-lesson-planner-classes-list">
                {classStatuses.map(cs => (
                    <div key={cs.scheduleClassId} className="ch-lesson-planner-class-col">
                        <span className="ch-lesson-planner-class-col-name">{cs.className}</span>
                        <LessonPlannerStatusButton
                            status={cs.lessonState}
                            onChange={(state) => onStatusChange(state, cs.scheduleClassId)}
                        />
                    </div>
                ))}
            </div>
        </div>
        <div style={{ padding: '0 16px' }}><Divider className="ch-divider" style={{ margin: '0 0 8px' }} /></div>
    </>
);

export default LessonPlannerClassStatusRow;
